
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { h as hasSlot } from './labels-mixin.js';
import PendoDivider from './pendo-divider.js';

var script = {
  name: 'PendoMultiselectOption',
  components: {
    PendoDivider
  },
  inject: ['multiselect'],
  props: {
    option: {
      type: [Object, String, Number],
      required: true
    },
    scrollActive: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    }
  },
  computed: {
    optionHeight() {
      return `${this.multiselect.optionHeight}px`;
    },

    dividerWidth() {
      if (this.multiselect.isFullWidth) {
        return '100%';
      }

      return `${this.multiselect.computedMenuWidth || this.multiselect.minMenuWidth}px`;
    },

    showGroupDividers() {
      return this.multiselect.groupDividers;
    },

    allowGroupSelect() {
      return this.multiselect.groupSelect;
    },

    isGroupOption() {
      return this.option.type === 'group';
    },

    isSelected() {
      if (this.isGroupOption && this.allowGroupSelect) {
        const groupValues = this.multiselect.filteredOptions.find(filteredOption => {
          return filteredOption[this.multiselect.groupLabelKey] === this.option.label;
        });
        return this.multiselect.isEntireGroupSelected(groupValues);
      }

      return this.multiselect.isOptionSelected(this.option);
    },

    isDisabled() {
      if (this.option.disabled) {
        return true;
      }

      return this.multiselect.multiple && this.multiselect.max === this.multiselect.model.length;
    },

    isHighlighted() {
      if (this.isGroupOption && !this.allowGroupSelect) {
        return false;
      }

      if (this.isDisabled) {
        return false;
      }

      return this.multiselect.showPointer && this.multiselect.pointer === this.index;
    },

    optionTitle() {
      if (hasSlot(this, 'option')) {
        return;
      }

      return this.optionLabel;
    },

    optionLabel() {
      return this.multiselect.getOptionLabel(this.option);
    },

    groupLabel() {
      return this.option[this.multiselect.groupLabelKey];
    }

  },
  methods: {
    onOptionSelect() {
      if (this.isGroupOption && !this.allowGroupSelect) {
        return;
      }

      this.multiselect.select(this.option);
    },

    onOptionHover() {
      if (this.scrollActive) {
        return;
      }

      if (this.isGroupOption && !this.allowGroupSelect) {
        return;
      }

      this.multiselect.pointerSet(this.index);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-multiselect__element",
    attrs: {
      "role": "option",
      "data-uid": _vm.index,
      "aria-selected": _vm.isSelected ? true : undefined
    }
  }, [_vm.option.divided ? _c('pendo-divider', {
    attrs: {
      "width": _vm.dividerWidth,
      "height": "16px"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isGroupOption && _vm.index !== 0 && _vm.showGroupDividers ? _c('pendo-divider', {
    attrs: {
      "width": _vm.dividerWidth,
      "height": "16px"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isGroupOption ? _c('div', {
    staticClass: "pendo-multiselect__group",
    class: {
      'is-highlighted': _vm.isHighlighted,
      'is-selected': _vm.isSelected,
      'pendo-multiselect__group--select': _vm.allowGroupSelect
    },
    style: {
      height: _vm.optionHeight
    },
    attrs: {
      "title": _vm.groupLabel
    },
    on: {
      "click": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) {
          return null;
        }

        if ('button' in $event && $event.button !== 0) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onOptionSelect($event);
      },
      "mousemove": _vm.onOptionHover
    }
  }, [_vm._t("optionGroup", [_c('span', {
    style: {
      lineHeight: _vm.optionHeight
    }
  }, [_vm._v("\n                " + _vm._s(_vm.groupLabel) + "\n            ")])])], 2) : _vm._e(), _vm._v(" "), !_vm.isGroupOption ? _c('div', {
    staticClass: "pendo-multiselect__option",
    class: {
      'is-disabled': _vm.isDisabled,
      'is-highlighted': _vm.isHighlighted,
      'is-selected': _vm.isSelected
    },
    style: {
      height: _vm.optionHeight
    },
    attrs: {
      "title": _vm.optionTitle
    },
    on: {
      "click": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) {
          return null;
        }

        if ('button' in $event && $event.button !== 0) {
          return null;
        }

        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onOptionSelect($event);
      },
      "mousemove": _vm.onOptionHover
    }
  }, [_vm._t("option", [_c('span', {
    style: {
      lineHeight: _vm.optionHeight
    }
  }, [_vm._v("\n                " + _vm._s(_vm.optionLabel) + "\n            ")])])], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-multiselect-option.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoMultiselectOption = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoMultiselectOption;
